export const styles = theme => ({
    treeContainer: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        color: 'white',
        textAlign: 'left',
        margin: '10px',
        backgroundColor: '#242424',
    },
    timeline: {
        height: '70px',
        margin: '10px'
    },
    loaderContainer: {
        position: 'absolute',
        margin: 0,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        textAlign: 'center',
        backgroundColor: '#242424'
    },
    loadingTitle: {
        position: 'relative',
        top: '40%',
    },
    verticalCenter: {
        position: 'relative',
        top: '50%',
        marginTop: '-250px',
        marginLeft: '-250px'
    },
});